import classNames from 'classnames'
import React from 'react'

type InformationProps = {
    backgroundColorClass?: string
    backgroundIcon?: React.ReactNode
    uspText?: string
    uspColor?: string
    children: React.ReactNode
    heading?: React.ReactNode

}

const Information: React.FC<InformationProps> = ({ backgroundColorClass = 'green', backgroundIcon, uspText = '', uspColor = 'yellow', heading = '', children }) => {
    return (
        <div className={classNames(
            'information-component',
            backgroundColorClass,
            { 'has-dark-bg': backgroundColorClass === 'black' }
        )}>
            {uspText.length > 0 && (
                <span className={`usp-color ${uspColor}`}>{uspText}</span>
            )}
            {heading && <h5 className="body-text">{heading}</h5>}

            {children}
            {backgroundIcon && (
                <div className="background-icon">
                    {backgroundIcon}
                </div>
            )}
        </div>
    )
}

export default Information;